import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { _getAlertList, _getAllAlertHistories, _deleteAlert } from '../../api/api'
import { useDispatch } from 'react-redux';
import { removeAlert } from '../../../Alert/slice/slice';
import SensorDetail from '../SensorList/SensorDetail.jsx'
import AlertEditor from './AlertEditor.jsx'
import InterventionModal from './InterventionModal.jsx'
import AlertDetailModal from './AlertDetailModal.jsx'
import ConfiguredAlertDetailModal from './ConfiguredAlertDetailModal.jsx'
import {OlangItem} from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import moment from 'moment'
import { PageHeader } from '../../../shared/PageHeader/PageHeader'
import { DataTableComponent } from '@omniyat/reactcomponents';
import { Dropdown } from 'primereact/dropdown';
import { useSelector } from 'react-redux';
import { fetchSites, getSites } from '../../../Site/slice/site.slice';

let alert_auto_text_1 = [
  "temperaturethresholdmin",
  "temperaturethresholdmax",
  "humiditythresholdmax",
  "humiditythresholdmin",
  "maxinactivebeforealert"
]

const AlertList = ({ onBack }) => {
  console.log(' NOUVELLE VERSION SIMPLIFIÉE SANS REDUX CHARGÉE !')
  
  const dispatch = useDispatch();
  const toast = useRef(null);
  
  const [alerts, setAlerts] = useState([])
  const [alertHistories, setAlertHistories] = useState([])
  const [loading, setLoading] = useState(true)
  const [showDetail, setShowDetail] = useState(false)
  const [selectedSensorMac, setSelectedSensorMac] = useState(null)
  const [error, setError] = useState(null)
  const [showCreateAlert, setShowCreateAlert] = useState(false)
  const [showInterventionModal, setShowInterventionModal] = useState(false)
  const [showAlertDetailModal, setShowAlertDetailModal] = useState(false)
  const [showConfiguredAlertDetailModal, setShowConfiguredAlertDetailModal] = useState(false)
  const [selectedAlertHistory, setSelectedAlertHistory] = useState(null)
  const [selectedAlertDetail, setSelectedAlertDetail] = useState(null)
  const [selectedConfiguredAlert, setSelectedConfiguredAlert] = useState(null)
  const [activeTab, setActiveTab] = useState('histories') // Par défaut sur l'historique
  const [selectedWorksite , setSelectedWorksite] = useState([])
  // États pour le filtrage par période (historique uniquement)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  
  // État pour le filtre de statut (historique uniquement)
  const [statusFilter, setStatusFilter] = useState('active') // 'active', 'unresolved', 'resolved', 'all'

  const worksites = useSelector(getSites)

  // Charger les données selon l'onglet actif
  useEffect(() => {
    if (activeTab === 'histories') {
      handleLoadAlertHistories()
    } else {
      handleLoadAlerts()
    }
  }, [activeTab])

  useEffect(()=>{
    dispatch(fetchSites())
  },[])

  const handleLoadAlerts = async () => {
    console.log('🚀 Chargement des alertes préconfigurées...')
    setLoading(true)
    setError(null)

    try {
      let filter = {}

      if(selectedWorksite){
        console.log('selectedWorksite:', selectedWorksite)
        filter.LocationObject= selectedWorksite?.type || ''
        filter.LocationID= selectedWorksite?.id || 0
      }
      const response = await _getAlertList(filter)
      console.log('📋 Réponse API alertes:', response)

      if (response && response.success && response.result) {
        setAlerts(response.result)
        console.log('✅ Alertes préconfigurées chargées:', response.result.length)
      } else {
        console.warn('⚠️ Aucune alerte préconfigurée trouvée ou format inattendu')
        setAlerts([])
      }
    } catch (error) {
      console.error('❌ Erreur lors du chargement des alertes préconfigurées:', error)
      setError('Erreur lors du chargement des alertes préconfigurées')
      setAlerts([])
    } finally {
      setLoading(false)
    }
  }

  const handleLoadAlertHistories = async () => {
    console.log('📅 Chargement de l\'historique des alertes...')
    setLoading(true)
    setError(null)

    try {
      let filter = {}

      if(selectedWorksite){
        console.log('selectedWorksite:', selectedWorksite)
        filter.LocationObject= selectedWorksite?.type || ''
        filter.LocationID= selectedWorksite?.id || 0
      }
      const response = await _getAllAlertHistories(filter)
      console.log('📋 Réponse API historique alertes:', response)

      if (response && response.success && response.result) {
        setAlertHistories(response.result || [])
        console.log('✅ Historique des alertes chargé:', response.result.length)
      } else {
        console.warn('⚠️ Aucun historique d\'alerte trouvé ou format inattendu')
        setAlertHistories([])
      }
    } catch (error) {
      console.error('❌ Erreur lors du chargement de l\'historique des alertes:', error)
      setError('Erreur lors du chargement de l\'historique des alertes')
      setAlertHistories([])
    } finally {
      setLoading(false)
    }
  }

  const handleDetail = (rowData) => {
    if (activeTab === 'histories') {
      // Pour l'historique : ouvrir le modal de détails d'alerte
      handleViewAlertDetail(rowData)
    } else {
      // Pour les alertes préconfigurées : ouvrir le modal de détails d'alerte préconfigurée
      handleViewConfiguredAlertDetail(rowData)
    }
  }

  useEffect(()=>{
    handleRefresh();
  },[selectedWorksite])

  // Templates pour les alertes préconfigurées
  const statusTemplate = (rowData) => {
    const isActive = rowData.isActive || rowData.IsActive
    return (
      <Badge 
        value={isActive ? 'Actif' : 'Inactif'} 
        severity={isActive ? 'success' : 'danger'}
        className="text-xs"
      />
    )
  }

  // Templates pour l'historique des alertes
  const historyStatusTemplate = (rowData) => {
    const isEnd = rowData.isEnd
    const isRead = rowData.isRead
    return (
      <div className="flex flex-column gap-1">
        <Badge 
          value={isEnd ? 'Terminé' : 'En cours'} 
          severity={isEnd ? 'success' : 'warning'}
          className="text-xs"
        />
        <Badge 
          value={isRead ? 'Traité' : 'Non traité'} 
          severity={isRead ? 'info' : 'danger'}
          className="text-xs"
        />
      </div>
    )
  }

  const historyDateTemplate = (rowData) => {
    // Utiliser moment.utc() pour préserver l'heure UTC originale
    // et éviter la conversion automatique en heure locale (+1h)
    const startDate = moment.utc(rowData.startDate)
    const endDate = rowData.endDate ? moment.utc(rowData.endDate) : null
    
    console.log('🕐 Date template - Données originales:', {
      startDate: rowData.startDate,
      endDate: rowData.endDate
    })
    console.log('🕐 Date template - Formatage UTC:', {
      startFormatted: startDate.format('DD/MM/YYYY HH:mm'),
      endFormatted: endDate ? endDate.format('DD/MM/YYYY HH:mm') : null
    })
    
    return (
      <div className="flex flex-column gap-1 text-xs">
        <div>
          <strong>Début:</strong><br/>
          {startDate.format('DD/MM/YYYY HH:mm')}
        </div>
        {endDate && (
          <div>
            <strong>Fin:</strong><br/>
            {endDate.format('DD/MM/YYYY HH:mm')}
          </div>
        )}
      </div>
    )
  }

  const historyDurationTemplate = (rowData) => {
    if (!rowData.startDate || !rowData.endDate) return '-'
    
    // Utiliser moment.utc() pour des calculs de durée cohérents
    const start = moment.utc(rowData.startDate)
    const end = moment.utc(rowData.endDate)
    const duration = moment.duration(end.diff(start))
    
    const hours = Math.floor(duration.asHours())
    const minutes = Math.floor(duration.asMinutes() % 60) // Correction du calcul des minutes
    
    return (
      <span className="text-xs">
        {hours > 0 ? `${hours}h ` : ''}{minutes}min
      </span>
    )
  }

  // Template pour le type d'alerte
  const typeTemplate = (rowData) => {
    const type = rowData.type || rowData.Type || 'Basse'
    
    // Mapping des nouveaux types vers les severities PrimeReact
    let severity = 'info'
    if (type === 'Haute' || type.toLowerCase() === 'error') {
      severity = 'danger'
    } else if (type === 'Moyenne' || type.toLowerCase() === 'warning') {
      severity = 'warning'
    } else if (type === 'Basse' || type.toLowerCase() === 'info') {
      severity = 'info'
    }
    
    return (
      <Badge 
        value={type} 
        severity={severity}
        className="p-mr-2"
      />
    )
  }


  // Template pour la date de création
  const dateTemplate = (rowData) => {
    const date = rowData.createdAt || rowData.CreatedAt
    if (!date) return '-'
    
    try {
      return moment(date).format('DD/MM/YYYY HH:mm')
    } catch (error) {
      return date
    }
  }

  // Template pour l'adresse MAC du capteur
  const srcObjectTemplate = (rowData) => {
    const srcObjectName = rowData.srcObjectName
    const macAddr = rowData.macAddr
    
    if (!srcObjectName && !macAddr) return '-'
    
    return (
      <div className="flex flex-column gap-1">
        {srcObjectName && (
          <div className="flex align-items-center gap-2">
            <i className={`pi pi-${rowData.srcObject === 'engin' ? 'tag' : 'building'} text-blue-600`}></i>
            <span className="font-semibold text-sm">{srcObjectName}</span>
          </div>
        )}
        {macAddr && (
          <div className="flex align-items-center gap-1">
            <i className="pi pi-wifi text-blue-400 text-xs"></i>
            <code className="text-xs text-600">{macAddr}</code>
          </div>
        )}
        { ['deposit', 'worksite'].includes(rowData.srcObject) && (
          <div className="ml-4 flex align-items-center gap-1">
            <code className="text-xs text-600">Zone</code>
          </div>
        )}
      </div>
    )
  }

  // Template pour la condition d'alerte
  const conditionTemplate = (rowData) => {
    const condition = rowData.condition
    if (!condition) return '-'
    
    return (
      <Badge 
        value={condition} 
        severity="info"
        className="p-mr-2"
      />
    )
  }

  //columns activeTab === 'histories'
  const columns = useMemo(()=>{
    let cols = [
    {
        "field": "alertCode",
        "header": "Code Alerte",
        "sortable": true,
        filter: true,
        "style": {
            "width": "150px"
        },
        "className": "font-semibold"
    },
    {
        "field": "message",
        "header": "Message",
        "sortable": true,
        "style": {
            "minWidth": "300px"
        },
        "className": "text-sm"
    },
    {
        "field": "condition",
        "header": "Condition",
		    body: conditionTemplate,
        "sortable": true,
        "style": {
            "width": "100px"
        }
    },
    {
        "header": "Période",
        'field': "periode",
		    body: historyDateTemplate,
        "sortable": true,
        "style": {
            "width": "180px"
        }
    },
    {
        "header": "Durée",
        'field': "Durée",
		    body: historyDurationTemplate,
        "sortable": true,
        "style": {
            "width": "80px"
        }
    },
	  {
        "field": "enginLabel",
        "header": "Déclancheur",
		    body: srcObjectTemplate,
        "sortable": true,
        "style": {
            "width": "200px"
        }
    },
    {
        "header": "Statut",
        "field": "Statut",
		    body: historyStatusTemplate,
        "sortable": true,
        "style": {
            "width": "120px"
        }
    }
    ]

    if(activeTab !== 'histories'){
      cols = [
          {
              "field": "code",
              "header": "Code Alerte",
              "sortable": true,
              "style": {
                  "width": "150px"
              },
              "className": "font-semibold"
          },
          {
              "field": "type",
              "header": "Type",
              body: typeTemplate,
              "sortable": true,
              "style": {
                  "width": "120px"
              }
          },
          {
              "field": "condition",
              "header": "Condition",
              body: conditionTemplate,
              "sortable": true,
              "style": {
                  "width": "120px"
              }
          },
          {
              "field": "message",
              "header": "Description",
              "sortable": true,
              "style": {
                  "minWidth": "250px"
              },
              "className": "text-sm"
          },
          {
              "field": "enginLabel",
              "header": "Capteur",
              body: srcObjectTemplate,
              "sortable": true,
              "style": {
                  "width": "200px"
              }
          },
          {
              "field": "createdAt",
              "header": "Créé le",
              body: dateTemplate,
              "sortable": true,
              "style": {
                  "width": "140px"
              }
          },
          {
              "field": "isActive",
              "header": "Statut",
              body: statusTemplate,
              "sortable": true,
              "style": {
                  "width": "100px"
              }
          }
      ]
    }
    return cols
  }, [activeTab])


  //actions 
  const actions = useMemo(()=>{
    return [
      {
        label: "Détail",
        code: 'detail',
        icon: "pi pi-eye text-blue-600",
        command: (e) => {
            handleDetail(e.item.data)   
        }
      },
      {
        label: "Modifier",
        visible: (r)=> !alert_auto_text_1.includes((r.text_1 || '').toLowerCase()),
        icon: "pi pi-pencil text-indigo-600",
        command: (e) => {
          handleEditAlert(e.item.data)
        }
      },
      {
        label: "Traiter",
        code: 'process',
        icon: "pi pi-wrench text-orange-600",
        command: (e) => {
          handleIntervention(e.item.data)
        }
      },
        
      {
        label: "Supprimer",
        icon: "pi pi-trash text-red-600",
        visible: (r)=> !alert_auto_text_1.includes((r.text_1 || '').toLowerCase()),
        command: (e) => {
          handleDeleteAlert(e.item.data)
        }
      }
    ].filter( o => activeTab !== 'alerts' ? ['process', 'detail'].includes(o.code) : o.code != 'process')
  }, [activeTab])
  // Fonction pour afficher le détail d'un capteur (comme dans SensorList)
  const handleViewDetail = (macAddr) => {
    console.log('🔍 Affichage détail capteur:', macAddr)
    setSelectedSensorMac(macAddr)
    setShowDetail(true)
  }

  const handleViewAlertDetail = (alertData) => {
    console.log('🔍 Affichage détail alerte:', alertData)
    setSelectedAlertDetail(alertData)
    setShowAlertDetailModal(true)
  }

  const handleViewConfiguredAlertDetail = (alertConfig) => {
    console.log('🔍 Affichage détail alerte préconfigurée:', alertConfig)
    setSelectedConfiguredAlert(alertConfig)
    setShowConfiguredAlertDetailModal(true)
  }

  const handleEditAlert = (alertData) => {
    console.log('✏️ Modification de l\'alerte:', alertData)
    // Passer l'alerte sélectionnée à l'éditeur pour modification
    setSelectedConfiguredAlert(alertData)
    setShowCreateAlert(true)
  }

  const handleDeleteAlert = (alertData) => {
    console.log('🗑️ Suppression de l\'alerte:', alertData)
    const alertName = alertData.code || alertData.label || 'cette alerte'
    
    confirmDialog({
      message: `Êtes-vous sûr de vouloir supprimer l'alerte "${alertName}" ?`,
      header: 'Confirmation de suppression',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Supprimer',
      rejectLabel: 'Annuler',
      accept: async () => {
        try {
          // Chercher l'ID dans différents champs possibles
          const alertId = alertData.UID || alertData.id || alertData.uid
          
          if (!alertId) {
            console.error('ID de l\'alerte non trouvé dans les champs UID, id, uid:', alertData)
            toast.current.show({
              severity: 'error',
              summary: 'Erreur',
              detail: 'ID de l\'alerte non trouvé',
              life: 3000
            });
            return
          }
          
          console.log('🗑️ Suppression de l\'alerte avec ID:', alertId)
          
          // Utiliser l'action Redux
          const result = await dispatch(removeAlert(alertId))
          
          if (result.payload && result.payload.success) {
            toast.current.show({
              severity: 'success',
              summary: 'Succès',
              detail: 'Alerte supprimée avec succès',
              life: 3000
            });
            // Actualiser la liste locale
            handleLoadAlerts()
          } else {
            console.error('❌ Erreur lors de la suppression:', result.payload)
            toast.current.show({
              severity: 'error',
              summary: 'Erreur',
              detail: 'Erreur lors de la suppression de l\'alerte',
              life: 3000
            });
          }
          
        } catch (error) {
          console.error('❌ Erreur lors de la suppression:', error)
          toast.current.show({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Erreur lors de la suppression de l\'alerte',
            life: 3000
          });
        }
      }
    });
  }

  const handleIntervention = (alertHistory) => {
    console.log('🛠️ Intervention sur l\'alerte:', alertHistory)
    setSelectedAlertHistory(alertHistory)
    setShowInterventionModal(true)
  }

  const handleInterventionSuccess = () => {
    console.log('✅ Intervention réussie, actualisation de la liste')
    // Rafraîchir la liste après intervention
    if (activeTab === 'histories') {
      handleLoadAlertHistories()
    }
  }

  // Fonction appelée après création d'une alerte
  const handleAlertCreated = () => {
    console.log('✅ Alerte créée, actualisation de la liste...')
    handleLoadAlerts()
  }

  // Navigation conditionnelle vers SensorDetail (comme dans SensorList)
  if (showDetail && selectedSensorMac) {
    return (
      <SensorDetail
        macAddress={selectedSensorMac}
        onBack={() => {
          setShowDetail(false)
          setSelectedSensorMac(null)
        }}
      />
    )
  }


  const handleRefresh = () => {
    if (activeTab === 'histories') {
      handleLoadAlertHistories()
    } else {
      handleLoadAlerts()
    }
  }

  

  // Fonction pour vérifier si une alerte a reçu une intervention
  const hasIntervention = (alert) => {
    // Vérifier commentaires simples
    const hasComments = alert.comment && typeof alert.comment === 'string' && alert.comment.trim() !== ''
    
    // Vérifier comments JSON
    let hasCommentsArray = false
    if (alert.comments) {
      // Si c'est déjà un array
      if (Array.isArray(alert.comments)) {
        hasCommentsArray = alert.comments.length > 0
      }
      // Si c'est une string JSON
      else if (typeof alert.comments === 'string' && alert.comments.trim() !== '') {
        try {
          const commentsArray = JSON.parse(alert.comments)
          hasCommentsArray = Array.isArray(commentsArray) && commentsArray.length > 0
        } catch (e) {
          // Si ce n'est pas du JSON valide, considérer comme un commentaire simple
          hasCommentsArray = alert.comments.trim() !== ''
        }
      }
      // Si c'est un objet
      else if (typeof alert.comments === 'object' && alert.comments !== null) {
        // Vérifier si l'objet a des propriétés significatives
        const keys = Object.keys(alert.comments)
        hasCommentsArray = keys.length > 0 && keys.some(key => {
          const value = alert.comments[key]
          return value !== null && value !== undefined && value !== ''
        })
      }
      // Si c'est un autre type non-null
      else if (alert.comments !== null && alert.comments !== undefined) {
        hasCommentsArray = true
      }
    }
    
    // Vérifier si marquée comme lue
    const isRead = alert.isRead === 1 || alert.isRead === true
    
    return (hasComments || hasCommentsArray) && isRead
  }

  // Fonction pour filtrer l'historique par période et statut
  const getFilteredHistories = () => {
    let filtered = alertHistories
    console.log('filtred histories avant:', filtered)
    try {
      if (statusFilter !== 'all') {
        filtered = filtered.filter(alert => {
          if (statusFilter === 'active') {
            // Alertes actives : isEnd === 0 ET isRead === 0
            return alert.isEnd === 0 && alert.isRead === 0
          } else if (statusFilter === 'unresolved') {
            // Non traitées : isRead === 0, comment null et comments: []
            const isUnread = alert.isRead == 0
            const hasNoComments = (!alert.comment || alert.comment === null || alert.comment === '') && 
                                 (!alert.comments || alert.comments === null || 
                                  (Array.isArray(alert.comments) && alert.comments.length === 0) ||
                                  (typeof alert.comments === 'object' && Object.keys(alert.comments).length === 0))
            return isUnread /*&& hasNoComments*/
          } else if (statusFilter === 'resolved') {
            // Traitées : isRead === 1 (peu importe isEnd)
            return alert.isRead == 1
          }
          return true
        })
      }
  
      // Filtrer par période
      if (startDate || endDate) {
        filtered = filtered.filter(alert => {
          const alertStartDate = moment(alert.startDate)
          
          // Vérifier la date de début
          if (startDate && alertStartDate.isBefore(moment(startDate))) {
            return false
          }
          
          // Vérifier la date de fin
          if (endDate && alertStartDate.isAfter(moment(endDate))) {
            return false
          }
          
          return true
        })
      }
    } catch (err) {
      console.error('Erreur lors du filtrage des historiques d\'alertes:', err)
    }
    
    return filtered
  }

  const getCurrentData = () => {
    return activeTab === 'histories' ? getFilteredHistories() : alerts
  }

  const header = (
    <div className="flex flex-column gap-3">
      {/* En-tête principal */}
      <div className="flex justify-content-between align-items-center">
        <div className="flex align-items-center gap-2">
          {onBack && (
            <Button 
              icon="pi pi-arrow-left" 
              label="Retour"
              onClick={onBack}
              className="p-button-outlined"
            />
          )}
          <h2 className="m-0"><OlangItem olang='alert.management' /></h2>
        </div>
        <div className="flex align-items-center gap-2">
          <Badge value={getCurrentData().length} className="p-mr-2" />
          {activeTab === 'alerts' && (
            <Button 
              icon="pi pi-plus" 
              label="Configurer une alerte"
              onClick={() => setShowCreateAlert(true)}
              className="p-button-success"
            />
          )}
          <Button 
            icon="pi pi-refresh" 
            label="Actualiser"
            onClick={handleRefresh}
            loading={loading}
            className="p-button-outlined"
          />
        </div>
      </div>
      
      {/* Onglets de navigation */}
      <div className="flex gap-2">
        <Button 
          label={<OlangItem olang='alert.history' />}
          icon="pi pi-calendar"
          onClick={() => setActiveTab('histories')}
          className={activeTab === 'histories' ? 'p-button-primary' : 'p-button-outlined'}
        />
        <Button 
          label="Alertes préconfigurées"
          icon="pi pi-cog"
          onClick={() => setActiveTab('alerts')}
          className={activeTab === 'alerts' ? 'p-button-primary' : 'p-button-outlined'}
        />
      </div>
      
      {/* Filtres de statut pour l'historique */}
      {activeTab === 'histories' && (
        <div className="p-3 border-round surface-50">
          <div className="flex flex-column gap-3">
            {/* Badges de filtrage par statut */}
            <div className="flex align-items-center gap-2 flex-wrap">
              <span className="font-semibold text-900">Filtrer par statut :</span>
              <Button
                label="Actives"
                icon="pi pi-exclamation-circle"
                onClick={() => setStatusFilter('active')}
                className={statusFilter === 'active' ? 'p-button-danger' : 'p-button-outlined'}
                badge={statusFilter === 'active' ? String(alertHistories.filter(a => a.isEnd === 0 && a.isRead === 0).length) : null}
                size="small"
              />
              <Button
                label="Non traitées"
                icon="pi pi-clock"
                onClick={() => setStatusFilter('unresolved')}
                className={statusFilter === 'unresolved' ? 'p-button-warning' : 'p-button-outlined'}
                badge={statusFilter === 'unresolved' ? String(alertHistories.filter(a => {
                  const isUnread = a.isRead === 0
                  const hasNoComments = (!a.comment || a.comment === null || a.comment === '') && 
                                       (!a.comments || a.comments === null || 
                                        (Array.isArray(a.comments) && a.comments.length === 0) ||
                                        (typeof a.comments === 'object' && Object.keys(a.comments).length === 0))
                  return isUnread /*&& hasNoComments*/
                }).length) : null}
                size="small"
              />
              <Button
                label="Traitées"
                icon="pi pi-check-circle"
                onClick={() => setStatusFilter('resolved')}
                className={statusFilter === 'resolved' ? 'p-button-success' : 'p-button-outlined'}
                badge={statusFilter === 'resolved' ? String(alertHistories.filter(a => a.isRead === 1).length) : null}
                size="small"
              />
              <Button
                label="Toutes"
                icon="pi pi-list"
                onClick={() => setStatusFilter('all')}
                className={statusFilter === 'all' ? 'p-button-primary' : 'p-button-outlined'}
                badge={statusFilter === 'all' ? String(alertHistories.length) : null}
                size="small"
              />
            </div>
            
            {/* Filtres de période */}
            <div className="flex align-items-center gap-3 flex-wrap">
              <span className="font-semibold text-900">Filtrer par période :</span>
              
              <div className="flex align-items-center gap-2">
                <label htmlFor="startDate" className="text-sm font-medium">Du :</label>
                <Calendar
                  id="startDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.value)}
                  showTime
                  hourFormat="24"
                  placeholder="Date de début"
                  className="w-auto"
                  dateFormat="dd/mm/yy"
                  showIcon
                />
              </div>
              
              <div className="flex align-items-center gap-2">
                <label htmlFor="endDate" className="text-sm font-medium">Au :</label>
                <Calendar
                  id="endDate"
                  value={endDate}
                  onChange={(e) => setEndDate(e.value)}
                  showTime
                  hourFormat="24"
                  placeholder="Date de fin"
                  className="w-auto"
                  dateFormat="dd/mm/yy"
                  showIcon
                />
              </div>
            </div>
            
            {(startDate || endDate || statusFilter !== 'all') && (
              <Button
                icon="pi pi-times"
                label="Réinitialiser tous les filtres"
                onClick={() => {
                  setStartDate(null)
                  setEndDate(null)
                  setStatusFilter('all')
                }}
                className="p-button-outlined p-button-sm"
              />
            )}
            
            <div className="text-sm text-600">
              {(startDate || endDate || statusFilter !== 'all') ? (
                <span>
                  <i className="pi pi-filter mr-1"></i>
                  {getFilteredHistories().length} alerte(s) sur {alertHistories.length}
                </span>
              ) : (
                <span>
                  <i className="pi pi-list mr-1"></i>
                  {alertHistories.length} alerte(s) au total
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )

  const currentData = getCurrentData()

  if (loading && currentData.length === 0) {
    return (
      <Card className="m-3">
        <div className="flex flex-column align-items-center justify-content-center p-4">
          <ProgressSpinner />
          <p className="mt-3">
            {activeTab === 'histories' ? 'Chargement de l\'historique des alertes...' : 'Chargement des alertes préconfigurées...'}
          </p>
        </div>
      </Card>
    )
  }

  if (error) {
    return (
      <Card className="m-3">
        <div className="flex flex-column align-items-center justify-content-center p-4">
          <i className="pi pi-exclamation-triangle text-red-500" style={{ fontSize: '3rem' }}></i>
          <h3 className="text-red-500 mt-3">Erreur</h3>
          <p className="text-center">{error}</p>
          <Button 
            label="Réessayer" 
            icon="pi pi-refresh"
            onClick={handleRefresh}
            className="mt-3"
          />
        </div>
      </Card>
    )
  }

  // Vérifier si on n'a aucune donnée du tout (pas de données chargées depuis l'API)
  const hasNoDataAtAll = activeTab === 'histories' ? alertHistories.length === 0 : alerts.length === 0
  
  
  // Si on affiche l'éditeur d'alerte, afficher la page AlertEditor
  if (showCreateAlert) {
    return (
      <AlertEditor
        onBack={() => {
          setShowCreateAlert(false)
          setSelectedConfiguredAlert(null) // Reset selection
          handleRefresh() // Actualiser la liste après création/modification
        }}
        selectedAlert={selectedConfiguredAlert}
      />
    )
  }

  const filterHeader = ()=>(
    <div className="flex align-items-center gap-2 ml-4">
      <label className="font-semibold text-700"><OlangItem olang='zone' />:</label>
      <Dropdown
        value={selectedWorksite}
        options={[{label: 'Tout' , value: 0}, ...worksites]}
        onChange={(e) => setSelectedWorksite(e.value)}
        placeholder="Sélectionner une zone"
        className="w-10rem"
        disabled={loading}
      />
      {loading && (
        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="4" />
      )}
    </div>
  )

  return (
    <>
      {/* Page Header */}
      <PageHeader
        titleOlang="alert.management"
        onBack={onBack}
        info={
          <div className="flex align-items-center gap-3">
            <div className="flex align-items-center gap-2">
              <i className={activeTab === 'histories' ? 'pi pi-calendar text-xl text-primary' : 'pi pi-cog text-xl text-primary'}></i>
              <span className="text-lg font-semibold">
                {activeTab === 'histories' ? 'Historique' : 'Préconfigurées'}
              </span>
            </div>
            {/* <div className="border-left-2 border-300" style={{ height: '30px' }}></div> */}
            {/* <div className="flex align-items-center gap-2">
              <i className="pi pi-exclamation-triangle text-xl text-primary"></i>
              <span className="text-lg font-semibold">
                {getCurrentData().length} alerte{getCurrentData().length > 1 ? 's' : ''}
              </span>
            </div> */}
            {activeTab === 'histories' && (
              <>
                <div className="border-left-2 border-300" style={{ height: '30px' }}></div>
                <div className="flex align-items-center gap-2">
                  <i className="pi pi-exclamation-circle text-xl text-red-500"></i>
                  <span className="text-lg font-semibold text-red-600">
                    {alertHistories.filter(a => a.isEnd === 0 && a.isRead==0).length} active(s)
                  </span>
                </div>
              </>
            )}
          </div>
        }
        className="m-3"
      />
      
      <Card className="m-3">
        <style jsx>{`
        :global(.p-datatable .p-datatable-emptymessage) {
          text-align: center !important;
          padding: 2rem !important;
          font-style: italic;
          color: #6c757d;
        }
      `}</style>
      {header}
      <DataTableComponent 
        tableId={`alerts-${activeTab}-list`}
        data={currentData}
        columns={columns}
        rowActions={actions}
        tableOptions = {{showGridlines: true}}
        tableTitle={filterHeader()}
        onNew={activeTab === 'alerts' ? ()=>setShowCreateAlert(true): null}
      />
      {/* Modal d'intervention sur l'historique des alertes */}
      <InterventionModal
        visible={showInterventionModal}
        onHide={() => setShowInterventionModal(false)}
        alertHistory={selectedAlertHistory}
        onSuccess={handleInterventionSuccess}
      />
      
      {/* Modal de détails d'alerte pour l'historique */}
      <AlertDetailModal
        visible={showAlertDetailModal}
        onHide={() => setShowAlertDetailModal(false)}
        alertHistory={selectedAlertDetail}
      />
      
      {/* Modal de détails d'alerte préconfigurée */}
      <ConfiguredAlertDetailModal
        visible={showConfiguredAlertDetailModal}
        onHide={() => setShowConfiguredAlertDetailModal(false)}
        alertConfig={selectedConfiguredAlert}
      />
      
      {/* Toast pour les notifications */}
      <Toast ref={toast} />
      
      {/* Dialog de confirmation */}
      <ConfirmDialog />
    </Card>
    </>
  )
}

export default AlertList
